import { useState, useEffect } from "react";
import TableTop from "../TableComponents/TableTop";
import { Table, TableBody } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MessagesInRequestTableHead from "../TableHeads/MessagesInRequestTableHead";
import MessagesInRequestTableRow from "../TableRows/MessagesInRequestTableRow";
import { getActiveRequestsMessages } from "../../../reduxStore/entities/messages";

const MessagesInActiveRequestsTable = () => {

    const [isTableShown, setIsTableShown] = useState(true);

    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedPartOffersWithMessages = useSelector((state) => state.messages.activeRequestsMessages);
    const count = useSelector((state) => state.messages.count);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedPartOffersWithMessages]);

    useEffect(() => {
        dispatch(getActiveRequestsMessages());
    }, []);

    if (!loaded) {
        return null;
    };


    return (
        <div style={styles.mainContainer}>
            <TableTop
                title={"Poruke u aktivnim zahtevima"}
                count={count}
                open={isTableShown}
                setOpen={setIsTableShown}
            />

            {isTableShown && (
                <div style={styles.tablePaddingDiv}>
                    <div style={styles.tableBorderDiv}>
                        <Table>
                            <MessagesInRequestTableHead />

                            <TableBody>

                                {fetchedPartOffersWithMessages.map((row, index) => (
                                    <MessagesInRequestTableRow
                                        key={index}
                                        partOffer={row}
                                    />
                                ))}

                            </TableBody>

                        </Table>
                    </div>
                </div>
            )}

        </div>
    );
};


export default MessagesInActiveRequestsTable;

const styles = {
    mainContainer: {
    },
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
        borderRight: "1px solid rgba(0, 0, 0, 0.12)"
    }
};